import { render, staticRenderFns } from "./TabHotelList.vue?vue&type=template&id=0b4b5e50&"
import script from "./TabHotelList.vue?vue&type=script&lang=js&"
export * from "./TabHotelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports